import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    testData: []
}

export const testSlice = createSlice({
    initialState,
    name: 'testSlice',
    reducers: {
        testInfo: () => initialState,
        setTestData:(state,action) => {
            state.testData = action.payload
        }
    }
})

export const {setTestData}  = testSlice.actions

export default testSlice